<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
    <v-footer padless color="transparent">
      <v-col class="text-center pt-5 pb-10 footertext" cols="12">
        &copy; TOHO CO., LTD.
      </v-col>
    </v-footer>
  </v-app>
</template>
<style></style>
<style scoped>
.footertext {
  font-family: 'Noto Sans JP', sans-serif;
  font-size: min(2vw, 12px);
  font-weight: normal;
}

.bgtop {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: top;
}

.flashicon {
  animation: flash 1.5s infinite;
}

@keyframes flash {

  0%,
  100% {
    filter: drop-shadow(0 0 15px rgba(255, 255, 172, 0.8));
  }

  7%,
  93% {
    filter: drop-shadow(0 0 12px rgba(255, 255, 172, 0.75));
  }

  16%,
  84% {
    filter: drop-shadow(0 0 10px rgba(255, 255, 172, 0.67));
  }

  50% {
    filter: drop-shadow(0 0 10px rgba(255, 255, 172, 0)) opacity(80%);
    ;
  }
}

.viewText {
  color: #EBD8BA !important;
  font-size: 14px !important;
  font-family: "Helvetica Neue",
    Arial,
    "Hiragino Kaku Gothic ProN",
    "Hiragino Sans",
    Meiryo,
    sans-serif;
}

.nowText {
  color: #EBD8BA !important;
  font-size: 14px !important;
  font-weight: bold !important;
  font-family: "Helvetica Neue",
    Arial,
    "Hiragino Kaku Gothic ProN",
    "Hiragino Sans",
    Meiryo,
    sans-serif;
}
</style>
<script>
// import axios from "axios";

export default {
  name: "App",

  data: () => ({

  }),
  created: async function () {

    // param処理
    this.$store.dispatch("initParam");
    console.log("shopkey", this.$store.getters.shopKey, this.$store.getters.urlParamId);

    this.$store.subscribe((mutation, state) => {
      if (this.$store.getters.redirectUrl) {
        console.log("redirect", this.$store.getters.redirectUrl);
        location.href = this.$store.getters.redirectUrl;
        return;
      }
      console.log("save local subscribe", mutation.type);
      if (!state.localUserHashKey) {
        console.log("☆NO SET USER", state);
        return;
      }
      console.log("App.vue", "$store.subscribe", mutation);
      if (["init", "initParam", "setSetting", "setMaintenance"].indexOf(mutation.type) == -1) {
        let saveData = {
          "nowPiece": this.$store.getters.nowPiece,
          "checkTos": this.$store.getters.isCheckTos,
          "localUserHashKey": this.$store.getters.localUserHashKey
        }
        console.log("★savedata", saveData, JSON.stringify(saveData));
        localStorage.setItem(this.$store.getters.shopKey + "_data", JSON.stringify(saveData));
      }

    });

    // this.checkAnalytics(0);

    // 他のページが開いてたら強制移動
    if (!this.$store.getters.isLoad && this.nowPath != "/") {
      this.$router.push({ name: 'loading', query: { "key": this.$store.getters.shopKey } });
    }


  },
  methods: {
    // checkAnalytics(count) {
    //   console.log("AAAAAAAAAAAAa")
    //   if (!count) count = 0;
    //   console.log("★checkAnalytics", count, this.$store.getters.analyticsGa4, typeof (gtag));
    //   if (typeof (this.$store.getters.analyticsGa4) == 'string' && typeof (gtag) != 'undefined') {
    //     console.log(gtag);
    //     // window.dataLayer = window.dataLayer || [];
    //     // function gtag() { dataLayer.push(arguments); }
    //     // gtag('js', new Date());

    //     // gtag('config', 'G-CZ89RP3E72');
    //   }
    //   if (count < 5) {
    //     setTimeout(() => {
    //       this.checkAnalytics(count + 1);
    //     }, 500);
    //   }

    // }
  },
  computed: {

    nowPath() {
      return this.$route.path;
    }
  },
  watch: {
    nowPath(newVar) {
      console.log("App.vue", "CHANGE PAGE", newVar);
      // let appDom = document.getElementById("app");
      // switch (newVar) {
      //   case "/present":
      //   case "/ofuro":
      //   case "/mission1":
      //   case "/mission2":
      //   case "/mission3":
      //   case "/mission4":
      //   case "/mission5":
      //   case "/keyword":
      //     this.viewMenu = true;
      //     appDom.classList.add("defaultBg");
      //     break;
      //   case "/maintenance":
      //   case "/top":
      //   case "/missioninfo":
      //   case "/map":
      //     this.viewMenu = true;
      //     appDom.classList.remove("defaultBg");
      //     break;
      //   default:
      //     this.viewMenu = false;
      //     appDom.classList.add("defaultBg");
      //     break;
      // }
    }
  }
};
</script>
